/**
 * Tab/browser close logout is handled in tabCloseLogout.js (bootstrap + pagehide).
 * This hook is kept so App.js does not need route changes.
 */
const useLogoutOnTabClose = () => {};

export default useLogoutOnTabClose;
